import React from 'react'
import styles from './set-visibility.styles'
import injectSheet from 'react-jss'
import {
  Modal,
  ModalHeader,
  ModalContent,
  ModalFooter
} from 'pobble-components/dist/modal'
import Button from 'pobble-components/dist/button'
import FormSelect from 'pobble-components/dist/form-elements/form-select'
import * as Yup from 'yup'
import { Formik } from 'formik'

const SetVisibility = ({
  classes,
  opened,
  requestClose = () => null,
  onSubmit,
  ids,
  visibility
}) => (
  <Modal isOpen={opened}>
    <ModalHeader>Set visibility for {ids.length} groups</ModalHeader>
    <Formik
      validationSchema={Yup.object().shape({
        groupVisibility: Yup.string().required('Please select a visibility')
      })}
      onSubmit={onSubmit}
      initialValues={{
        groupVisibility: visibility
      }}>
      {props => {
        const {
          values,
          handleChange,
          handleSubmit,
          handleBlur,
          errors,
          isValid
        } = props
        return (
          <form onSubmit={handleSubmit}>
            <ModalContent legacy className={classes.modalContent}>
              <FormSelect
                validationError={errors.groupVisibility}
                name="groupVisibility"
                value={values.groupVisibility}
                onChange={handleChange}
                onBlur={handleBlur}>
                <option value="">Select</option>
                <option value="public">Public</option>
                <option value="internal">Internal</option>
              </FormSelect>
            </ModalContent>
            <ModalFooter className={classes.footer}>
              <Button
                simple
                tall
                type="button"
                className={classes.cancel}
                action={requestClose}>
                Cancel
              </Button>
              <Button disabled={!isValid} tall type="submit">
                Set visibility
              </Button>
            </ModalFooter>
          </form>
        )
      }}
    </Formik>
  </Modal>
)

export default injectSheet(styles)(SetVisibility)
